export default __webpack_public_path__ + "static/Cryofridge-17c276e7bff2cd5eeecf8e100955881d.png";